(function($) {
    var documentLoad = function() {
        $('.calendar-slider').each(function() {
            var calendarSliderModule = this;
            var options = {
                nextArrow: $(calendarSliderModule).parent().find('.next-arrow'),
                prevArrow: $(calendarSliderModule).parent().find('.prev-arrow'),
                dots: false,
                autoplay: false,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                ]
            };
            $(calendarSliderModule).on('init' , function() {
                $(calendarSliderModule).removeClass('loading');
            });
            $(calendarSliderModule).slick(options);
            $(calendarSliderModule).each(function() {
                $(this).find('.calendar-slide-inner-wrapper').matchHeight();
            });
        });
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/calendar-slider.js